import { GregorianCalendar } from '@internationalized/date';

/**
 * Create a new `GregorianCalendar` instance.
 * Use this method instead of importing factory method `createCalendar` from the library.
 * It allows tree-shaking and reduces the bundle size.
 * see for more details https://react-spectrum.adobe.com/internationalized/date/Calendar.html#calendar-identifiers
 */
export function createCalendar(): GregorianCalendar {
  return new GregorianCalendar();
}
